import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AxiosContext } from '../contextManager/axios.context';
import { endpoints } from '../constants/endpoints';
import { UserDetails } from '../types/schemas/abc'; // Assuming this is your tutor type
// import { SubjectsGrid } from '../styles/profile/form.style';

// This function fetches the tutors. It's called by React Query.
const fetchParents = async (axios: any, subjects: string[]) => { // You can use a more specific type for your axios instance
  const params = new URLSearchParams();
  if (subjects.length > 0) {
    params.append('subjects', subjects.join(','));
  }

  const endpoint = `${endpoints.parents}?${params.toString()}`;
  const { data } = await axios.get(endpoint);
  return data as UserDetails[];

};

// This is the custom hook your components will use.
export const useParents = (subjects: string[] = []) => {
  const axios = useContext(AxiosContext);

  // useQuery manages all the fetching, caching, and state for you.
  return useQuery({
    queryKey: ['parents', subjects], // A unique key for this data
    queryFn: () => fetchParents(axios, subjects),
    enabled: subjects.length > 0,
  });
};